export default __webpack_public_path__ + "images/assets/e244bd64ea47751dc485a6eaa0ce10b0.svg";